export default {
    headerRow: ['Suite', 'Tenant', 'SQ FT'],
    rows: {'no-row': {valueCells: []}}
}